/**
 * 系统内置方法集，正常情况下您不应该修改或移除此文件
 * */

import { cloneDeep } from 'lodash';

/**
 * @description 根据当前路由，找打顶部菜单名称
 * @param {String} currentPath 当前路径
 * @param {Array} menuList 所有路径
 * */
function getHeaderName (currentPath, menuList,fullPath) {//获取头部菜单
	if(!menuList || !currentPath)return ;//如果没有菜单或者没有当前路由，直接返回
    for(var i=0,menu;menu=menuList[i++];){//遍历菜单
		if(isSiderChildrenOpenNames(currentPath,menu.children,fullPath)){//如果当前路由是菜单的子菜单
			window.localStorage.oa_currentMenuPath = menu.path;//设置当前菜单
			return menu.path;//返回当前菜单
		}
	}
    //没找到就说明非菜单形式的，那就判断是否以root目录开头,【匹配不到则不切换主菜单】
   /* for(var i=0,menu;menu=menuList[i++];){
    	if(currentPath.indexOf(menu.path)===0){
    		return menu.path
    	}
    }*/
    //还没找到就读localStorage
    return window.localStorage.oa_currentMenuPath ? window.localStorage.oa_currentMenuPath : '/bpm';//返回当前菜单
    
}

function isSiderChildrenOpenNames(currentPath,menuList,fullPath){//判断当前路由是否是菜单的子菜单
	if(!menuList && menuList.length ==0)return false;//如果没有菜单，直接返回
	
	for(var i=0,menu;menu=menuList[i++];){//遍历菜单
		if(currentPath === menu.path || fullPath === menu.path){
			return true
		}
		
		if(menu.children && menu.children.length>0 && isSiderChildrenOpenNames(currentPath,menu.children,fullPath)){
			return true;
		}
	}
	
	return false;
}


function transferMenu (menu, headerName) {
    if (menu.children && menu.children.length) {
        return menu.children.reduce((all, item) => {
            all.push({
                path: item.path,
                header: headerName
            });
            const foundChildren = transferMenu(item, headerName);
            return all.concat(foundChildren);
        }, []);
    } else {
        return [menu];
    }
}

export { getHeaderName };

/**
 * @description 根据当前顶栏菜单 name，找到对应的二级菜单
 * @param {Array} menuList 所有的二级菜单
 * @param {String} headerName 当前顶栏菜单的 name
 * */
function getMenuSider (menuList, headerName = '') {
    if (headerName) {
    	for(var i=0,menu;menu=menuList[i++];){
    		if(menu.path===headerName){
    			return menu.children;
    		}
    	}
    } 
    return [];
}

export { getMenuSider };

/**
 * @description 根据当前路由，找到其所有父菜单 path，作为展开侧边栏 open-names 依据
 * @param {String} currentPath 当前路径
 * @param {Array} menuList 所有路径
 * */
function getSiderSubmenu (currentPath, menuList) {
    const allMenus = [];
    menuList.forEach(menu => {
        const menus = transferSubMenu(menu, []);
        allMenus.push({
            path: menu.path,
            openNames: []
        });
        menus.forEach(item => allMenus.push(item));
    });

    const currentMenu = allMenus.find(item => item.path === currentPath);
    return currentMenu ? currentMenu.openNames : [];
}

function transferSubMenu (menu, openNames) {
    if (menu.children && menu.children.length) {
        const itemOpenNames = openNames.concat([menu.path]);
        return menu.children.reduce((all, item) => {
            all.push({
                path: item.path,
                openNames: itemOpenNames
            });
            const foundChildren = transferSubMenu(item, itemOpenNames);
            return all.concat(foundChildren);
        }, []);
    } else {
        return [menu].map(item => {
            return {
                path: item.path,
                openNames: openNames
            }
        });
    }
}

export { getSiderSubmenu };

/**
 * @description 递归获取所有子菜单
 * */
function getAllSiderMenu (menuList) {
    let allMenus = [];

    menuList.forEach(menu => {
        if (menu.children && menu.children.length) {
            const menus = getMenuChildren(menu);
            menus.forEach(item => allMenus.push(item));
        } else {
            allMenus.push(menu);
        }
    });

    return allMenus;
}

function getMenuChildren (menu) {
    if (menu.children && menu.children.length) {
        return menu.children.reduce((all, item) => {
            const foundChildren = getMenuChildren(item);
            return all.concat(foundChildren);
        }, []);
    } else {
        return [menu];
    }
}

export { getAllSiderMenu };

/**
 * @description 将菜单转为平级
 * */
function flattenSiderMenu (menuList, newList) {
    menuList.forEach(menu => {
        let newMenu = {};
        for (let i in menu) {
            if (i !== 'children') newMenu[i] = cloneDeep(menu[i]);
        }
        newList.push(newMenu);
        menu.children && flattenSiderMenu(menu.children, newList);
    });
    return newList;
}

export { flattenSiderMenu };

/**
 * @description 判断列表1中是否包含了列表2中的某一项
 * 因为用户权限 access 为数组，includes 方法无法直接得出结论
 * */
function includeArray (list1, list2) {
    let status = false;
    list2.forEach(item => {
        if (list1.includes(item)) status = true;
    });
    return status;
}

export { includeArray };



function getSiderOpenNames(currentPath,menuList,isTurnHead){
	const openNames = [];
	for(var i=0,menu;menu=menuList[i++];){
		// 当前选中的菜单
		if(menu.children && menu.children.length >0 && getSiderChildrenOpenNames(currentPath,menu.children,openNames)){
			openNames.push(menu.path);
			continue;
		}
	}
	if(!isTurnHead && openNames.length==0){
		return openNames;
	}
	
	// 切换子菜单时，将默认打开的菜单，默认展开，未切换不默认展开
	for(var i=0,menu;menu=menuList[i++];){
		if(menu.children && menu.children.length >0 && menu.opened){
			openNames.push(menu.path);
		}
	}
	
	return openNames;
}

function getSiderChildrenOpenNames(currentPath,menuList,openNames){
	if(!menuList && menuList.length ==0)return false;
	
	for(var i=0,menu;menu=menuList[i++];){
		if(menu.children && menu.children.length>0 && getSiderChildrenOpenNames(currentPath,menu.children,openNames)){
			openNames.push(menu.path);
		}
	}
	
	for(var i=0,menu;menu=menuList[i++];){
		if(currentPath === menu.path ){
			return true
		}
	}
	
	
	return false;
}

export { getSiderOpenNames };
